import { call, put, select } from 'redux-saga/effects';

import { updatePatient } from 'connect/actions';
import { sendToLogger } from 'connect/saga/helpers';
import { selectDataUserAuthenticated } from 'connect/selectors';
import { apiUpdatePatient } from 'endpoints/patient-endpoints';

import { SagaHandler } from '../SagaHandler';
import { UpsertIterableUser } from '../upsert-iterable-user/upsert-iterable-user';

/*
  Updates patient in the API and Redux silently (no errors, loading, or success messages)
  Useful for non-critical updates where we don't want errors to block the user
*/
class _UpdatePatientSilently extends SagaHandler {
  constructor() {
    super({
      actionName: 'data/UPDATE_PATIENT_SILENTLY',
    });
  }

  * saga({ payload }) {
    try {
      const { patientId, startedSearchAt, startedCheckoutAt, lastSeenAt } = payload;
      // Expand this as needed
      const body = {
        ...startedSearchAt && { startedSearchAt },
        ...startedCheckoutAt && { startedCheckoutAt },
        ...lastSeenAt && { lastSeenAt },
      };

      const isUserLoggedIn = yield select(selectDataUserAuthenticated);

      if (!Object.keys(body).length || !patientId || !isUserLoggedIn) {
        return;
      }

      // Update patient in API
      const patient = yield call(apiUpdatePatient, patientId, body);
      // Update patient in Redux
      yield put(updatePatient(patient));
      // Update user in Iterable - this will sync the updates to the patient we just made to Iterable
      yield call(UpsertIterableUser.saga, {
        payload: { allowEmptyDataFields: true },
      });
    } catch (error) {
      sendToLogger(error, 'updatePatientSilently');
    }
  }
}

export const UpdatePatientSilently = new _UpdatePatientSilently();
